<template>
  <div>

    <!-- page banner -->
    <page-banner
      v-if="tempQuote"
      :title="pageTitle"
      :sub-title="$t('airportparking.results.subtitle')"
      :promo-box="false"
    />

    <div class="main-area container style04">
      <div class="main-holder" :class="{ 'results' : false }">

        <!-- filters -->
        <hotel-filter v-if="tempQuote" v-model="tempQuote" />

        <!-- results -->
        <div class="hotel-detail">

          <!-- overview -->
          <hotel-overview v-if="!loading" />

          <!-- hotels -->
          <div v-if="results.products && results.products.airporthotel && tempQuote">
            <hotel-item
              v-for="(product, key) in sortedResults" 
              :key="key"
              :product="product"
            ></hotel-item>
          </div>
          
          <!-- no results -->
          <div class="text-center" v-else-if="!loading">
            <h3 class="mt-5 mb-0">{{ $t('airportparking.results.filters.empty') }}</h3>
          </div>
          <div v-else-if="loading">
            <h3 class="mt-5 mb-0">{{ $t('airportparking.results.filters.searching') }}</h3>
          </div>
        </div>
      </div>
    </div>

    <!-- timeout modal -->
    <timeout v-if="tempQuote" />

    <!-- fancy loader -->
    <steps-loader :loading="loading" />

    <!-- more info -->
    <more-info />

  </div>
</template>

<script>
import { sync, call, get } from "vuex-pathify";
import { eventBus } from "@/eventBus";
import mixins from "@/mixins";
import { PageBanner, Timeout, HotelFilter, HotelOverview, HotelItem, MoreInfo, StepsLoader } from "@/components";
import * as _ from "lodash";

export default {
  name: 'hotel-results-view',
  components: { PageBanner, Timeout, HotelFilter, HotelOverview, HotelItem, MoreInfo, StepsLoader },
  mixins: [mixins.load, mixins.quoteGen, mixins.pageview],
  computed: {
    quote: sync("quote"),
    tempQuote: sync("quoteTemp"),
    results: sync("results"),
    needVehicle: sync("payment/needVehicle"),
    moreInfo: sync("modals/moreInfo"),
    pageTitle: get("results/pageTitle"),
    sortedResults() {
      return _.cloneDeep(this.results.products.airporthotel).sort((a, b) => parseFloat(a.price) - parseFloat(b.price))
    }
  },
  methods: {
    load: call("results/getResults"),
    addToCart: call("cart/addToCart"),
    updateQuote: call("quote/updateQuote"),
  },
  mounted() {
    eventBus.$on('SEARCH',  () => {
      this.loading = true;
      this.tempQuote._timestamp = new Date();

      this.$router.push({ query: this.tempQuote }, () => {})

      this.updateQuote(this.tempQuote).then(() => {
        this.load("silent").then(() => {
          this.loading = false;

          this.sendPageView();
        });
      });
    });
    
    eventBus.$once('SELECTED', value => {
      this.needVehicle = true;
      this.addToCart({ category: 'airporthotel', ...value }).then(() => {

        let productId = value.product_id || null
        let quote = this.tempQuote;

        // eslint-disable-next-line
        let { _timestamp, quoteID, manual_discount, transfer_type, resortA, serviceCode, ...params } = quote;

        this.$router.push({ path: '/payment', query: { ...params, productId }  }, () => {});
        this.moreInfo = false;
      });
    });
  },
  beforeDestroy() {
    eventBus.$off(['SEARCH']);
  },
};
</script>